import { render, staticRenderFns } from "./PreviewAccountStatements.vue?vue&type=template&id=0aa88676&scoped=true"
import script from "./PreviewAccountStatements.vue?vue&type=script&lang=js"
export * from "./PreviewAccountStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa88676",
  null
  
)

export default component.exports